import map from 'lodash/fp/map'
import flow from 'lodash/fp/flow'
import indexOf from 'lodash/fp/indexOf'
import { RootState } from 'typedRedux/configureStoreWithHistory'

export const isAdventureInItinerary = (
  adventures: {
    id: string
  }[],
  adventureId: string
) => flow(map('id'), indexOf(adventureId))(adventures) > -1

export const getPricingAdjustmentData = (
  changeRequest: RootState['changeRequest']['data']
) => {
  if (!changeRequest) return null
  if (!changeRequest.changed?.length) return null // Do not show adjustment if nothing has changed

  return {
    originalPrice: changeRequest?.original_price,
    newPrice: changeRequest.new_price,
    totalPaid: changeRequest.total_paid,
    deferredPaymentEligible: changeRequest.deferred_payment_eligible,
    dueNowAmount: changeRequest.due_now_amount,
    dueOnAmount: changeRequest.due_on_amount,
    dueOnDate: changeRequest.due_on_date,
    refundAmount: changeRequest.calculated_refund?.total_refund,
    voucherRefundAmount: changeRequest.calculated_refund?.voucher_refund_amount,
  }
}
